/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../IconsAPI'
], function(APIFactory, IconsAPI) {

	class Icons {
		constructor() {
			this._api = APIFactory.createAPI(this, [IconsAPI]);
			this._iconCache = {};
		}

		getAPI() {
			return this._api;
		}

		registerIcons(iconList = []) {
			iconList.forEach(item => {
				if(item.icon) {
					this._iconCache[item.id] = item.icon.default;
				} else if(item.icons) {
					this._iconCache[item.id] = item.icons.default;
				}
			});
		}

		getIcon(iconId){
			return this._iconCache[iconId];
		}
	}

	return Icons;
});
